import * as React from 'react';
import { Icon } from '../icon/icon';

export const IconMenu: React.FC = () => (
    <Icon viewBox="0 0 24 10" fill="none">
        <path fill="currentColor" d="M0 2h24V0H0zM0 10h24V8H0z" />
    </Icon>
);
